// extracted by mini-css-extract-plugin
module.exports = {"Signup":"pr_a"};